import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from '@mui/material';
import { useRegisterPasskey } from './hooks/useRegisterPasskey';
import { setPasskeysState } from './passkeys.slice';
import { useTranslation } from 'react-i18next';

export const PasskeySetupDialog = (props) => {
  const dispatch = useDispatch();
  const { setupDialogOpen } = useSelector((state) => state.passkeys);
  const { t } = useTranslation('passkeys');

  const { handleRegisterPasskey } = useRegisterPasskey();
  const form = useForm({
    defaultValues: {
      passkeyName: '',
    },
  });

  const handleClose = () => {
    dispatch(setPasskeysState({ setupDialogOpen: false }));
    form.reset();
  };

  const handleSubmit = (data) => {
    handleRegisterPasskey({
      passkeyName: data.passkeyName,
      onSuccess: () => {
        form.reset();
        handleClose();
      },
    });
  };

  return (
    <Dialog open={setupDialogOpen} onClose={handleClose}>
      <DialogTitle>{t('setupDialogTitle')}</DialogTitle>
      <DialogContent>
        <Controller
          name="passkeyName"
          control={form.control}
          rules={{
            required: t('requiredField'),
            minLength: {
              value: 3,
              message: t('nameMinLengthError'),
            },
            maxLength: {
              value: 100,
              message: t('nameMaxLengthError'),
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              autoFocus
              margin="dense"
              label={t('nameFieldPlaceholder')}
              type="text"
              fullWidth
              error={!!form.formState.errors.passkeyName}
              helperText={form.formState.errors.passkeyName?.message}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={form.handleSubmit(handleSubmit)}
          disabled={!form.watch('passkeyName')}
          variant="contained"
        >
          {t('continue')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
